import { collection, deleteDoc, doc, getDocs, setDoc } from 'firebase/firestore'
import { firestore, iamAuth } from '@/lib/firebase'
import { GoalSchema, type Goal } from './types'

function requireUid(): string {
  const uid = iamAuth.currentUser?.uid
  if (!uid) throw new Error('Not signed in')
  return uid
}

/** Lists every goal owned by the current user. Indexed by category
 *  for the budget table's per-row lookup. */
export async function fetchGoals(): Promise<Goal[]> {
  const uid = requireUid()
  const snap = await getDocs(collection(firestore, 'users', uid, 'goals'))
  const out: Goal[] = []
  for (const d of snap.docs) {
    const parsed = GoalSchema.safeParse(d.data())
    if (parsed.success) out.push(parsed.data)
  }
  return out
}

export async function saveGoal(goal: Goal): Promise<void> {
  const uid = requireUid()
  await setDoc(doc(firestore, 'users', uid, 'goals', goal.id), goal)
}

export async function deleteGoal(goalId: string): Promise<void> {
  const uid = requireUid()
  await deleteDoc(doc(firestore, 'users', uid, 'goals', goalId))
}
